<template>
  <div class="_margin-bottom-30">
    <h4 class="question _margin-bottom-30">Choose an Electric Vehicle</h4>

    <div v-show="!quote.electricVehicle.make">
      <h6 class="_margin-top-20 _margin-bottom-10">
        <uiv-btn type="primary" size="md" @click="onDontKnow">Select</uiv-btn> a vehicle
      </h6>

      <div class="row _margin-bottom-30" v-if="session.evOnly">
        <div class="col-sm-12">
          <label for="registrationEv">Or enter registration:</label>
          <validation-messages label="Vehicle registration" :$v="$v.electricVehicle.registrationNumber">
            <div class="vrn">
              <div class="vrn-input">
                <form-field class="text-center" id="registrationEv" type="alpha-numeric" maxlength="7"
                  v-model="quote.electricVehicle.registrationNumber"
                  :error="$v.electricVehicle.registrationNumber.$error"
                  @change="quote.electricVehicle.registrationNumber = quote.electricVehicle.registrationNumber.toUpperCase()" />
              </div>

              <uiv-btn type="primary" @click="onGetVehicle(quote.electricVehicle.registrationNumber)"
                :disabled="requesting">
                <loader :show="requesting" />Search
              </uiv-btn>
            </div>
          </validation-messages>
        </div>

        <div class="col-xs-12 col-md-5">
          <small>
            Selectable options and registration searches are available only for Car or Light Commercial
            Vehicle (LCV) classes that are Battery powered Electric Vehicles (BEVs) only.
          </small>
        </div>
      </div>

      <no-registration-vehicle ref="noReg" :electric-vehicle="true" @onClose="onCloseNoRegistration" />

      <div class="alert alert-danger" v-if="vehicleFound == 'notFound'">
        Vehicle could not be found
      </div>
      <div class="alert alert-danger" v-if="vehicleFound == 'notValid'">
        The registration you entered does not belong to a Car or Light Commercial Vehicle (LCV) and/or is not a
        Battery Electric vehicle (BEV).
      </div>
    </div>

    <div class="row _margin-top-20" v-show="quote.electricVehicle.make">
      <div class="col-md-7">
        <div class="detail-card">
          <div class="detail-card-title">
            Your Vehicle
            <button type="button" class="btn btn-ghost btn-xs pull-right" @click="onChangeVehicle">Change</button>
          </div>

          <vehicle-thumbnail :src="quote.electricVehicle.image" />
          <p class="_margin-top-0 _margin-bottom-0">
            <b>{{ quote.electricVehicle.make }} {{ quote.electricVehicle.model }}</b>
            <!-- {{ ' ' }}
            <span class="badge" v-if="quote.electricVehicle.isEv">
              {{ quote.electricVehicle.batterySize }} kWh
            </span>
            <span class="badge" v-else>
              {{ quote.electricVehicle.engineSize }} cc
            </span> -->
          </p>
        </div>
      </div>

      <div class="col-md-9 _margin-top-20" v-if="!quote.electricVehicle.isEv">
        <div class="alert alert-danger">
          The registration you entered does not belong to a Car or Light Commercial Vehicle (LCV) and/or is
          not a Battery Electric vehicle (BEV).
        </div>
      </div>
    </div>

    <div class="card-footer">
      <div class="col-xs-6">
        <uiv-btn @click="goToQuestion({ type: 'prev' })">Back</uiv-btn>
      </div>

      <div class="col-xs-6 text-right">
        <uiv-btn type="primary" @click="onGoToQuestion('next')"
          :disabled="!quote.electricVehicle.make || !quote.electricVehicle.isEv">Next</uiv-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import NoRegistrationVehicle from './NoRegistrationVehicle';
import VehicleThumbnail from '../../vehicle-thumbnail/VehicleThumbnail';

export default {
  name: 'ElectricVehicle',
  data() {
    return {
      vehicleFound: null
    };
  },
  props: {
    $v: Object
  },
  computed: {
    ...mapState({
      session: ({ session }) => session.quote_journey_session,
      quote: ({ quote }) => quote,
      vehicle: ({ lookups }) => lookups.vehicle,
      requesting: ({ lookups }) => lookups.requesting.vehicle,
      vehicleMakeList: ({ lookups }) => lookups.vehicleMakes,
      vehicleModelList: ({ lookups }) => lookups.vehicleModels,
      vehicleEngineList: ({ lookups }) => lookups.vehicleEngines
    })
  },
  methods: {
    ...mapActions({
      findVehicle: 'lookups/findVehicle',
      resetAddress: 'quote/resetAddress',
      resetList: 'lookups/resetList',
      goToQuestion: 'quote_questions/goToQuestion'
    }),
    onNoReg() {
      if (!this.$refs.noReg) return;
      this.$refs.noReg.openModal();
    },
    onReset() {
      this.quote.electricVehicle.make = null;
      this.quote.electricVehicle.makeId = null;
      this.quote.electricVehicle.modelId = null;
      this.quote.electricVehicle.registrationNumber = null;
      this.vehicleFound = null;
      this.resetList('compareVehicles');
    },
    onChangeVehicle() {
      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Electric Vehicle' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Change' });
      this.$store.dispatch('tracing/saveActions');
      this.onReset();
    },
    async onGetVehicle(registrationNumber) {
      this.$v.electricVehicle.registrationNumber.$touch();
      if (this.$v.electricVehicle.registrationNumber.$invalid) return;
      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Electric Vehicle' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Vehicle Search' });
      this.$store.dispatch('tracing/addAction', { name: 'Value', value: registrationNumber });
      await this.$store.dispatch('tracing/saveActions');

      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Electric Vehicle' });
      this.$v.$reset();
      const vehicle = await this.findVehicle({ registrationNumber, ev: true });

      if (vehicle == 404) {
        this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Vehicle Not Found' });
        this.$store.dispatch('tracing/saveActions');
        return this.vehicleFound = 'notFound';
      }

      if (vehicle == 409) {
        this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Vehicle Invalid' });
        this.$store.dispatch('tracing/saveActions');
        return this.vehicleFound = 'notValid';
      }

      this.quote.electricVehicle = { ...vehicle, dontKnow: false };
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Vehicle Search' });
      this.$store.dispatch('tracing/addAction', { name: 'Value', value: `${vehicle.make} ${vehicle.model}` });
      this.$store.dispatch('tracing/saveActions');
    },
    onDontKnow(e) {
      e.preventDefault();
      this.onReset();
      this.quote.electricVehicle.dontKnow = true;
      this.$refs.noReg.openModal();
      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Electric Vehicle' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Select' });
      this.$store.dispatch('tracing/saveActions');
    },
    onCloseNoRegistration(vehicle) {
      if (vehicle) {
        this.quote.electricVehicle = { ...this.quote.electricVehicle, ...vehicle };

        this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Done' });
        this.$store.dispatch('tracing/addAction', { name: 'Value', value: `${vehicle.make} ${vehicle.model}` });
        this.$store.dispatch('tracing/saveActions');
      } else if (!this.quote.electricVehicle.makeId && !this.quote.electricVehicle.modelId) {
        this.onReset();
      }
    },
    async onGoToQuestion(type) {
      this.$v.electricVehicle.$touch();

      if (this.$v.electricVehicle.$invalid) return;

      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Electric Vehicle' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Next' });

      await this.goToQuestion({ type });
      await this.$store.dispatch('tracing/saveActions');
    }
  },
  components: {
    NoRegistrationVehicle,
    VehicleThumbnail
  }
};
</script>

<style lang="scss" scoped>
.vrn {
  display: flex;
  text-align: center;

  .vrn-input {
    margin-right: 10px;
  }
}

.vrn-input {
  overflow: hidden;
  position: relative;
  border: 1px solid #000;
  border-radius: 4px;
  background-color: #F3B701;
  padding-left: 23px;
  max-width: 200px;

  .form-control {
    box-shadow: -25px 0 0 #4eab26;
    border: none;
    border-radius: 0 4px 4px 0;
    background-color: transparent;
    color: #000;
    letter-spacing: 2px;
    font-weight: bold;

    &:hover,
    &:focus {
      border: none;
    }
  }
}

.detail-card {
  padding: 0 15px 15px 15px;
  border-radius: 10px;
  border: 1px solid #dadada;

  .detail-card-title {
    min-height: 46px;
    font-size: 16px;
    padding: 13px 15px;
    margin: 0 -15px 10px -15px;
    border-bottom: 1px solid #dadada;
    font-weight: bold;

    .btn {
      position: relative;
      top: -3px;
    }
  }
}
</style>
